module.exports = __webpack_public_path__ + "static/media/zdj-reb1.53136837.JPG";